import React from 'react'

const SavedLoc = () => {
  return (
    <div>SavedLoc</div>
  )
}

export default SavedLoc